/**
 * P1-E · gtag 走 consent + idle 门控。
 *
 * 取代 theme.liquid 底部同步注入的 gtag 块（原 L224-232）：
 *   <script async src="https://www.googletagmanager.com/gtag/js?id=G-FKTS4096YE"></script>
 *   <script>window.dataLayer=...; gtag('js',...); gtag('config', ...)×3</script>
 *
 * 新方案：
 *   1. 立即挂 gtag / dataLayer 的 stub，保证任何早期调用不报错、参数入队；
 *   2. 等 ConsentAppLoader 判定同意（GDPR 地区需用户点同意；其它地区立即通过）；
 *   3. 同意后走 requestIdleCallback（timeout 3s 兜底）加载真实 gtag.js；
 *   4. gtag.js 自动消费 dataLayer 里的早期调用，加载完成后再追加 js/config 初始化。
 *
 * 依赖 assets/consent-app-loader.js 已先加载（theme.liquid 中 defer 顺序保证）。
 *
 * 参见 docs/adr/0005-gtag-consent-idle-gating.md。
 */
(() => {
  const IDS = ['G-FKTS4096YE', 'AW-18443858055', 'AW-18481995435'];
  const SRC = 'https://www.googletagmanager.com/gtag/js?id=' + IDS[0];
  const SERVER_CONTAINER_URL = 'https://samduo-sgtm.cloud.run';

  window.dataLayer = window.dataLayer || [];

  // stub：真实 gtag.js 加载前，所有调用以 arguments 形式入队，加载后重放
  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  let loaded = false;
  let loading = false;
  let attempts = 0;
  const MAX_ATTEMPTS = 2;

  function loadRealGtag() {
    if (loaded || loading) return;
    loading = true;
    attempts += 1;

    const s = document.createElement('script');
    s.async = true;
    s.src = SRC;
    s.onload = () => {
      loading = false;
      loaded = true;
      try {
        window.gtag('js', new Date());
        for (let i = 0; i < IDS.length; i++) {
          window.gtag('config', IDS[i], { server_container_url: SERVER_CONTAINER_URL });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[gtag-loader] init failed', e);
      }
    };
    s.onerror = () => {
      loading = false;
      // eslint-disable-next-line no-console
      console.warn('[gtag-loader] failed to load', SRC);
      if (attempts < MAX_ATTEMPTS) window.setTimeout(loadRealGtag, 1500);
    };
    document.head.appendChild(s);
  }

  function schedule() {
    const ric =
      window.requestIdleCallback ||
      function (cb) {
        return window.setTimeout(() => cb({ didTimeout: false, timeRemaining: () => 0 }), 200);
      };
    ric(loadRealGtag, { timeout: 3000 });
  }

  function start() {
    if (typeof ConsentAppLoader !== 'undefined' && typeof ConsentAppLoader.whenConsented === 'function') {
      ConsentAppLoader.whenConsented(schedule);
    } else if (typeof window.Shopify !== 'undefined' && window.Shopify.customerPrivacy) {
      // 兜底：consent-app-loader.js 未加载但 Shopify API 已在
      const api = window.Shopify.customerPrivacy;
      const consent = api.getTrackingConsent && api.getTrackingConsent();
      if (api.userCanBeTracked && api.userCanBeTracked() || consent === true || consent === 'yes') {
        schedule();
      } else {
        document.addEventListener('trackingConsentAccepted', schedule, { once: true });
      }
    } else {
      // 极端兜底：无 consent API，走 idle 直接加载（保持与原同步注入等价的行为）
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', schedule);
      } else {
        schedule();
      }
    }
  }

  start();
})();
